import { render } from "./EventCard.vue?vue&type=template&id=110bda81&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=110bda81&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-110bda81"

export default script